module.exports = __webpack_public_path__ + "static/media/6-iron.774c0100.png";